import { render, staticRenderFns } from "./DischargedCoacheeModal.vue?vue&type=template&id=ec5e2e7a"
import script from "./DischargedCoacheeModal.vue?vue&type=script&lang=js"
export * from "./DischargedCoacheeModal.vue?vue&type=script&lang=js"
import style0 from "./DischargedCoacheeModal.vue?vue&type=style&index=0&id=ec5e2e7a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports